export default __webpack_public_path__ + "static/media/spin-bg-22.56f8177d.png";